import { makeRequest } from './https';
import { CreateReport, ReportDetails, ReportType, SubmitClientDecisionRequest } from '../types/report.type';
import {
  FinancialViewParams,
  FinancialViewResponse,
  PeriodOptionsResponse,
  PeriodPresetKey,
  FinancialViewGroupBy,
} from '../types/financialView.type';

export const addReport = (data: CreateReport) => {
  return makeRequest({
    url: '/report',
    method: 'post',
    data,
  });
};

export const getPeriodOptions = (organizationId: string): Promise<PeriodOptionsResponse> => {
  return makeRequest({
    url: '/report/period-options',
    method: 'get',
    params: { organization_id: organizationId },
  });
};

export const getFinancialView = (params: FinancialViewParams): Promise<FinancialViewResponse> => {
  return makeRequest({
    url: '/report/financial-view',
    method: 'get',
    params: {
      currency: 'SAR',
      language: 'ar',
      ...params,
    },
  });
};

export interface GetReportsParams {
  limit?: number;
  offset?: number;
  period_preset?: PeriodPresetKey;
  group_by?: FinancialViewGroupBy;
  report_type?: ReportType | string;
  date_after?: string;
  date_before?: string;
}

export const getReports = (organizationId: string, params?: GetReportsParams) => {
  return makeRequest({
    url: '/report',
    method: 'get',
    params: { organization_id: organizationId, ...params },
  });
};

export const getReport = (reportId: string) => {
  return makeRequest({
    url: `/report/${reportId}`,
    method: 'get',
  });
};

export const updateReport = (reportId: string, data: { data: any }) => {
  return makeRequest({
    url: `/report/${reportId}`,
    method: 'put',
    data,
  });
};

export const deleteReport = (reportId: string) => {
  return makeRequest({
    url: `/report/${reportId}`,
    method: 'delete',
  });
};

export const approveReport = (reportId: string) => {
  return makeRequest({
    url: `/report/${reportId}/approve`,
    method: 'post',
    data: {},
  });
};

export const rejectReport = (reportId: string, reason?: string) => {
  return makeRequest({
    url: `/report/${reportId}/reject`,
    method: 'post',
    data: { reason: reason || '' },
  });
};

export const submitClientDecision = (
  reportId: string,
  data: SubmitClientDecisionRequest,
): Promise<ReportDetails> => {
  return makeRequest({
    url: `/report/${reportId}/client-decision`,
    method: 'post',
    data,
  });
};
